export enum Routes {
  ContactRouter = "*",
  ContactSearchPageRouter = "/contact/search",
  ContactDetailPageRouter = '/contact/:id/detail/',
  ContactEditPageRouter = '/contact/:id/edit/',
  ContactNewPageRouter = '/contact/new',
  ContactAddressSearchPageRouter = "/contact/:id/address",
  ContactEmailSearchPageRouter = "/contact/:id/email",
  ContactPhoneSearchPageRouter = "/contact/:id/phone",
  ContactNoteSearchPageRouter = "/contact/:id/note",
  ContactRepresentativeSearchPageRouter = "/contact/:id/representative",
  ContactCostSearchPageRouter = "/contact/:id/cost",
  ContactImportXlsPageRouter = '/contact/import/xls',
  ContactExportXlsPageRouter = '/contact/export/xls',
}
